import { render } from "./LayerContextMenuComp.vue?vue&type=template&id=b53b1bec&scoped=true"
import script from "./LayerContextMenuComp.vue?vue&type=script&lang=js"
export * from "./LayerContextMenuComp.vue?vue&type=script&lang=js"

import "./LayerContextMenuComp.vue?vue&type=style&index=0&id=b53b1bec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b53b1bec"]])

export default __exports__